import { render } from "./StudyProgress.vue?vue&type=template&id=2c39c6be"
import script from "./StudyProgress.vue?vue&type=script&lang=js"
export * from "./StudyProgress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__